export default "__VITE_ASSET__DdqARtN8__"